import { Draft, SharingDraft } from '@/types';
import { getConfigurations } from '@/model/draft/getConfigurations';
import { createDesignsForSpecialConfigs } from '@/model/product/createDesignsForSpecialConfigs';
import { mapDraftToSharingDraft } from './mapDraftToSharingDraft';

export const getSharingDraft = async (
  draft: Draft,
  progressCallback: () => void = () => {}
): Promise<SharingDraft> => {
  const tasks = await createDesignsForSpecialConfigs(getConfigurations(draft), progressCallback);
  return mapDraftToSharingDraft(draft, tasks);
};
